import { acceptPhoneValue } from '../../field-viewer/shared-normalizers';
export const dextPhoneViewer = {
    normalizeLoadedValue: acceptPhoneValue
};

//# sourceMappingURL=definition-viewer.js.map